import styled from "@emotion/styled";

import { Loading } from "scmp-app/components/common/loading";

export const FallbackLoading = styled(Loading)`
  margin-block: 40px;
  margin-inline: 0;
`;
